module monitoringApp.components {
    //@ts-ignore
    class ReportBarChartComponentController implements ng.IComponentController {

        private axisXLabel: string;
        private axisYLabel: string;
        private failedLabel: string;
        private failedData: Array<[number, number]> = [];


        private barData = () => {
            return [{
                values: this.failedData,
                key: "Failed",
                color: '#f7464a'
            }
            ]
        }

        private barOptions = {
            chart: {
                type: 'discreteBarChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55
                },
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                showValues: true,
                valueFormat: function (d) {
                    return d3.format(',f')(d);
                },
                color: function () {
                    return '#f7464a';
                },
                duration: 500,
                xAxis: {
                    //@ts-ignore
                    axisLabel: this.axisXLabel,
                    tickFormat: function (d) {
                        return d3.format('d')(d);
                    },
                },
                yAxis: {
                    //@ts-ignore
                    axisLabel: this.axisYLabel,
                    axisLabelDistance: -10,
                    tickFormat: function (d) {
                        return d3.format('d')(d);
                    },
                },
                callback: (chart) => {
                    this.refreshCharts();
                }
            }
        };

        constructor(private $timeout) {
            this.barOptions.chart.xAxis.axisLabel = this.axisXLabel;
            this.barOptions.chart.yAxis.axisLabel = this.axisYLabel;
            console.log(this)
        }

        $inject = ['$timeout'];

       
        private refreshCharts = () => {
            this.$timeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }
    }



    class ReportBarChart implements ng.IComponentOptions {

        public bindings: { [binding: string]: string } = {
            axisYLabel: "@",
            axisXLabel: "@",
            failedLabel: "@",
            failedData: "="
        }

        public controller = ReportBarChartComponentController;

        constructor() {
        }

        public template =
        `<nvd3 options="$ctrl.barOptions" data="$ctrl.barData" class="with-3d-shadow with-transitions"></nvd3>`;

    }

    angular.module("ultimateMonitoringApp").component("reportBarChart", new ReportBarChart());
}